<app-layout>
    <admin-reports-tab :referrer="filters.referrer" section="deposits"></admin-reports-tab>
    <h1 class="mt-10 mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.edit', filters.referrer)" v-if="filters.referrer">Go Back - </inertia-link> Deposits
    </h1>
    <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">
            <label class="block text-gray-700">Type:</label>
            <select v-model="form.type" class="mt-1 w-full form-select rounded">
                <option :value="null" />
                <option value="coin">Coin</option>
                <option value="fiat">Fiat</option>
            </select>
        </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Status</th>
                <th class="px-6 pt-6 pb-4">ID</th>
                <th class="px-6 pt-6 pb-4">TXN</th>
                <th class="px-6 pt-6 pb-4">Amount</th>
                <th class="px-6 pt-6 pb-4">Address</th>
                <th class="px-6 pt-6 pb-4">Payment ID</th>
                <th class="px-6 pt-6 pb-4">Network</th>
                <th class="px-6 pt-6 pb-4">User</th>
                <th class="px-6 pt-6 pb-4">Confirms</th>
            </tr>
            <tr v-for="deposit in deposits.data" :key="deposit.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" :type="deposit.status == 'confirmed' ? 'green' : 'orange'">
                            {{ deposit.status == 'confirmed' ? 'Confirmed' : 'Pending' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ deposit.deposit_id }}
                    </span>
                </td>
                <td class="border-t">
                    <span v-if="deposit.txn && deposit.txn_link" class="px-6 py-4 flex items-center">
                    
                        <a v-if="deposit.network.slug == 'erc20' || deposit.network.slug == 'eth'" class="text-indigo-500" target="_blank" :href="'https://etherscan.io/tx/' + deposit.txn">{{ format_string(deposit.txn, 10) }}</a>
                        <a v-else-if="deposit.network.slug == 'bep20' || deposit.network.slug == 'bnb'" class="text-indigo-500" target="_blank" :href="'https://bscscan.com/tx/' + deposit.txn">{{ format_string(deposit.txn, 10) }}</a>
                        <a v-else class="text-indigo-500" target="_blank" :href="deposit.txn_link">{{ format_string(deposit.txn, 10) }}</a>
                        
                        <font-awesome-icon v-if="deposit.txn" class="text-gray-600 ml-2 cursor-pointer" icon="copy" @click="doCopy(deposit.txn)" />
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ deposit.amount }} {{ deposit.currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <div class="px-6 py-4 flex items-center">
                        {{ format_string(deposit.address, 10) }}
                        <font-awesome-icon v-if="deposit.address" class="text-gray-600 ml-2 cursor-pointer" icon="copy" @click="doCopy(deposit.address)" />
                    </div>
                </td>
                <td class="border-t">
                    <div class="px-6 py-4 flex items-center">
                        {{ format_string(deposit.payment_id, 5) }}
                        <font-awesome-icon v-if="deposit.payment_id" class="text-gray-600 ml-2 cursor-pointer" icon="copy" @click="doCopy(deposit.payment_id)" />
                    </div>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ deposit.network.name }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ deposit.user.email }}<br> ID: {{ deposit.user.id }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ deposit.confirms }}
                    </span>
                </td>
            </tr>
            <tr v-if="deposits.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No deposits found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="deposits.links" />
</app-layout>
